import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { actionHistory } from '../../../store';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';
import DieElement from '../../dice-tray/die.svelte';
import type { Die } from '../die.type';

export class Reactive extends Modifier {
  static readonly baseTitle = 'Reactive';
  static readonly baseText = 'Automatically reroll any lowest face dierolls. Stable.';
  static readonly baseIcon = 'reflex';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Reactive.baseTitle;
  text = Reactive.baseText;
  icon = Reactive.baseIcon;
  tags: Array<ModifierTags> = [...Reactive.baseTags];
  priority = Reactive.basePriority;

  update(stacks: number, params: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    const focus = this.owner.statusEffects.find((modifier) => modifier.type === StatusEffect.Focus);
    if (!focus) {
      this.delay = false;
    }
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }

  rollMid(
    diceElements: Array<DieElement>,
    dice: Array<Die>,
    promises: Array<Promise<void | boolean>>,
  ) {
    // check if dice rolled value is 6, and if so reroll it
    dice.forEach((die, index) => {
      if (die.activeFace == 0 && diceElements[index]) {
        // diceElements[index].roll();
        promises.push(diceElements[index].roll());
      }
    });
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Reactive, Reactive);
